import { downloadExcelReportNoYear } from 'helpers/downloadExcelReport'
import React, { useCallback, useState } from 'react'

import { Button } from "reactstrap"
import Cargando from './Cargando'

type PropsButtonDownloadNormalReport = {
    api: string,
    nombreArchivo?: string

}

type StateButtonDownloadNormalReport = {
    loadingApi: boolean,
}

export default function ButtonDownloadNormalReport(props: PropsButtonDownloadNormalReport) {
    const defaultState: StateButtonDownloadNormalReport = {
        loadingApi: false
    }
    const classUsandoBoton = "btnEspolAceptar";

    const [stateButtonDownload, setstateButtonDownload] = useState(defaultState)

    const HandleClickButton = useCallback(
        async () => {
            setstateButtonDownload({ ...stateButtonDownload, loadingApi: true })
            const status = await downloadExcelReportNoYear(props.api, props.nombreArchivo)
            setstateButtonDownload({ ...stateButtonDownload, loadingApi: false })
        }, [stateButtonDownload, props]
    )


    const ButtonLoading = () => {
        return (
            <Button
                className={classUsandoBoton}
            >
                Descargando Reporte... <Cargando />
            </Button>

        )
    }

    const ButtonExcel = () => {
        return (
            <Button
                className={classUsandoBoton}
                onClick={() => HandleClickButton()}
            >
                Descargar Reporte
            </Button>
        )
    }

    if(stateButtonDownload.loadingApi){
        return ButtonLoading()
    }
    else{
        return ButtonExcel()
    }
    
}
